import React, { useState } from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { getMultilineTruncation } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { SmartLink } from '../../../components/ClickableComponents/SmartLink';
import { HighlightText } from '../../../components/HighlightText/HighlightText';
import { PlayImage } from '../../../components/Image/PlayImage';
import { ShowImageOverlay } from '../../../components/Teaser/TeaserActions/ShowImageOverlay';
import { usePath } from '../../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowSearchResult = ({
  show,
  imageSize = 320,
  searchTerm
}) => {
  const [isHovering, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const {
    videoShowPath
  } = usePath();
  return /*#__PURE__*/_jsxs(StyledShowSearchResult, {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    children: [/*#__PURE__*/_jsxs(SmartLink, {
      to: videoShowPath(show),
      "aria-label": show.title,
      isInternal: true,
      state: {
        show
      },
      children: [/*#__PURE__*/_jsx(PlayImage, {
        aspectRatio: '16/9',
        src: show.imageUrl,
        width: imageSize,
        alt: show.title
      }), /*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(HighlightText, {
          text: show.title,
          highlight: searchTerm
        })
      })]
    }), /*#__PURE__*/_jsx(ShowImageOverlay, {
      show: show,
      aspectRatio: 16 / 9,
      isHovering: isHovering,
      isFocused: isFocused,
      showFavoriteAction: true
    })]
  });
};
const Title = styled.div.withConfig({
  displayName: "ShowSearchResult__Title",
  componentId: "sc-1t55ks0-0"
})(["margin-top:17px;", ";color:", ";", ";", "{", ";}"], Fonts.regular(18), Colors.GREY_d2d2d2, getMultilineTruncation(2, 24), Viewports.for('small'), Fonts.regular(16));
const StyledShowSearchResult = styled.div.withConfig({
  displayName: "ShowSearchResult__StyledShowSearchResult",
  componentId: "sc-1t55ks0-1"
})(["display:block;position:relative;&:hover{", "{color:", ";}}"], Title, Colors.WHITE);